import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { ReferenciaContenido } from '../../../interfaces/ReferenciaContenido';
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { useForm, SubmitHandler } from "react-hook-form";
import { navigate } from "gatsby-link";
import { saveForm, getToken } from "../../../services/formServices";
import FormWizard from "../../molecules/form-wizard/FormWizard";
import arrowLeft from "../../../assets/images/icons/flecha-izq.png";
import FormInput from "../../atoms/form-input/FormInput";
import Button from "../../atoms/button/button";
import Modal from "../../ui/modal/Modal";
import './FormForoInclusivo.scss'
import '../form-por-talento/FormPorTalento.scss'
import { BLOCKS } from '@contentful/rich-text-types';
import Breadcrumb, { CustomBreadcrumb } from "../../atoms/breadcrumb/breadcrumb";
import useBrowserMode from '../../../shared/hooks/useBrowserMode';
import warningSvg from "../../../assets/images/icons/icon-alert.svg";
import ToastAdvertiser from "../../atoms/toast-advertiser/toastAdvertiser";
import { getAllMunicipalities } from "../../../services/municipalities";
import FormResult from "../../molecules/form-result/formResult";
import Loading from "../../atoms/loading/loading";
import ModalDecision from "../../atoms/modal-decision/ModalDecision";
import ModalAge from "../../molecules/modal-age/ModalAge";
import ArrowRigth from "../../atoms/icons/ArrowRigth";
import useDisableFormData from "./query/useDisableFormData";
import rawToReact from "../../../utils/rawToReact";
import contentfulRenderOptions from "../../../utils/contentfulRenderOption";

type Inputs = {
    example: string
    exampleRequired: string
}

type MunicipalityDTO = {
   id:             number;
   codeSap:        string;
   name:           string;
   departmentDTO?: MunicipalityDTO;
}

const alianzaBreadcrumb: CustomBreadcrumb[] = [
    {
        title: "personas",
        url: "/servicio-de-empleo/personas"
    },
    {
        title: "proyectos-inclusion-laboral",
        url: "/servicio-de-empleo/personas/proyectos-inclusion-laboral"
    },
    {
        title: "alianza",
        url: "/servicio-de-empleo/personas/proyectos-inclusion-laboral/alianza"
    },
    {
        title: "inscripción",
    }
]


const FormForoInclusivo = (props : ReferenciaContenido) => {
    const disabledForms = useDisableFormData(); 
    const containerRef = useRef<HTMLDivElement>(null);
    const [activeStep, setActiveStep] = useState<number>(0);
    const [showModalCancelar, setShowModalCancelar] = useState<boolean>(false);
    const [wizards, setWizards] = useState<any[]>([]);
    const [congrats, setCongrats] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);
    const [hasNoAuthorization, setHasNoAuthorization] = useState<boolean>(false);
    const [showAgeModal, setShowAgeModal] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showModalLeaveForm, setShowModalLeaveForm] = useState(false);
    const [showModalAgeAlianza, setShowModalAgeAlianza] = useState(false);
    const { window } = useBrowserMode();
    const [titulosFormulario, setTitulosFormulario] = useState(props?.referenciaFormularios[0]?.titulosFormulario ?? "");
    const formResult = props.referenciaFormularios[0]?.referenciaPreguntasFrecuentes?? "";
    const formResultSuccessful = formResult[0]?.referenciaPlantillaContenido?.[0] ?? "";
    const formResultError = formResult[0]?.referenciaPlantillaContenido?.[1] ?? "";
    let pathNameFixed = "";
    const formId = props.referenciaFormularios[0].idFormulario;
    const formIsAlianza = window.location.pathname.includes("/alianza/");
    const formIsFiftyMore = window.location.pathname.includes("/empleo-mayores-de-50/") || formId === 22 ;

   const checkIfFormIsDisabled = (): { disabled: boolean; conntent?: typeof disabledForms["fiftymore"] } => {
      if (formIsFiftyMore && disabledForms?.fiftymore) {
         const modalData = disabledForms?.fiftymore
         return {
            disabled: !modalData?.formularioCeidActivo,
            conntent: modalData
         }
      }

      return {
         disabled: false
      }
   }

   const disabledModalData = checkIfFormIsDisabled();
   

    const ageRequired = titulosFormulario
        .flatMap(titulo => titulo.referenciaFormulario)
        .find(ref => ref.nombreId === "birthdate")?.maximosCaracteres;  

    const getPathSegments = () => {
        const pathname = window.location.pathname;
        const segments = pathname.split('/').filter(Boolean);
        pathNameFixed = `${segments.slice(-4).join('/')}`;
        return pathNameFixed;
    };

    const handleBack = () => {
        setActiveStep(activeStep - 1);
    }
    const createWizards = () => {
        let newWizards: any[] = [];
        for (let i = 0; i < titulosFormulario.length; i++) {
            if (titulosFormulario[i]) {
                newWizards.push({
                    description: titulosFormulario[i].tituloSeccion,
                    idx: i,
                });
            }
        }
        
        setWizards([...newWizards]);
    };

    const municipalitiesList = async () => {
        try {
            const data = await getAllMunicipalities();
            const municipalities : string[] = [];

            const shouldOnlyUseAntioquiaMunicipalities = formIsAlianza;

           if (shouldOnlyUseAntioquiaMunicipalities) {
              const antioquiaMunicipalities = (data?.data?.data as MunicipalityDTO[])?.filter((municipality) => {
                 return municipality?.departmentDTO?.id === 1 || municipality?.departmentDTO?.name === "Antioquia"
              }) || []

              municipalities.push(...antioquiaMunicipalities.map((municipality) => municipality.name?.toUpperCase()));
           } else {
              Object.entries(data.data.data).forEach(([key, value]) => {
                 municipalities.push(value.name + " - " + value.departmentDTO.name);
              });
           }
            municipalities.sort();

            // Agrega los municipalities como options al campo de tipo select correspondiente
            Object.entries(
                titulosFormulario
            ).forEach(([seccionIndex, seccion]) => {
                seccion.referenciaFormulario.forEach((field, fieldIndex) => {
                    if (field.nombreId === "municipality") {
                        titulosFormulario[seccionIndex].referenciaFormulario[fieldIndex].listaSelect = municipalities;
                    }
                });            
            });
        } catch (error) {
            console.log("API Error:", error);
        }
    };

    useEffect(() => {
        createWizards();
        municipalitiesList();
    }, []);

    const {
        register,
        handleSubmit,
        watch,
        control,
        setValue,
        formState: { errors, isValid },
    } = useForm<Inputs>({mode:"onChange"})

    const onSubmit: SubmitHandler<Inputs> = async (data) => {
         // Verificar si el formulario está deshabilitado
         if(disabledModalData?.disabled) return

        try {
            setIsLoading(true);
            const token = await getToken();
            const formattedDate = new Date().toLocaleDateString('es-ES');
            const disabilityAnswer = Array.isArray(data.disabilityName) ? data.disabilityName.join(", ") : "";

            const answers = Object.entries(data).map(([key, value]) => ({
                contentfulId: key,
                answer: key === "disabilityName" 
                    ? disabilityAnswer
                    : typeof value === "boolean" 
                        ? String(value) 
                        : value,
            }));

            answers.push({
                contentfulId: "registerDate",
                answer: formattedDate,
            });

            const isMentoriaRequired = [22, 24].includes(Number(props.referenciaFormularios[0].idFormulario));
            if(isMentoriaRequired){
                answers.push({
                    contentfulId: "fecha_mentoria",
                    answer: ' ',
                });
            }

            const mappedData = {
                idForm: props.referenciaFormularios[0].idFormulario,
                answers,
            };

            saveForm(mappedData, token).then((response)=>{
                if (response.data.status === 200) {
                    setIsLoading(false)
                    setCongrats(true);
                    dataLayerCreation();
                }else if(formResultError != ""){
                    setIsLoading(false)
                    setError(true);
                }
            });
        } catch (error) {
            if(formResultError != ""){
                setIsLoading(false)
                setError(true);
            }
        }
    }

    const dataLayerCreation = () => {
        window.dataLayer = window.dataLayer || [];
        
        const tagName = `${props.contentful_id === "58FLfeRXWFMTzlL2BayeGA" ? "finalizar_inscripción_foro_inclusivo" : "programa_50+_fin_inscripción"}`
        const alianzaTagName = "p_alianza_form_enviar"

        window.dataLayer.push({
            'event': 'confirmacionEnvioExitosoFormulario',
            'envioformulario': formIsAlianza ? alianzaTagName : tagName
        });
    }

    const closeCancelForm = () => {
        setShowModalCancelar(false);
        setShowAgeModal(false)
    };
    
    const watchedValues = watch();
    const blockName : string = "o-form-foro";

    const dataAuthorizationFields = Object.fromEntries(
        Object.entries(watchedValues).filter(
            ([key, value]) => key.startsWith('dataAuthorization') && key !== 'dataAuthorizationImage'
        )
    );

    const options = {
        renderNode: {
            [BLOCKS.LIST_ITEM]: (node, children) => (
                <li className="list-item">
                    <img src={props.referenciaFormularios[0].imagenFormulario.file.url} /> {children}
                </li>
            ),
        },
    };

    const validateHiddenFields = () => {
        const fieldsToUpdate = [
            { field: "disabilityName", condition: watchedValues["disability"] === "Si" },
            { field: "pensionType", condition: watchedValues["havePensionIncome"] === "Si" },
        ];

        setTitulosFormulario((prev) => {
            return prev.map((section) => ({
                ...section,
                referenciaFormulario: section.referenciaFormulario.map((field) => {
                    const matchingField = fieldsToUpdate.find((item) => item.field === field.nombreId);
                    return matchingField
                        ? { ...field, deshabilitado: !matchingField.condition }
                        : field;
                }),
            }));
        });
    }

    const validateAge = () => {
        const birthDate = watchedValues["birthdate"]
        const [day, month, year] = birthDate.split("-").map(Number);
        const birthDateObj = new Date(year, month - 1, day);
        const today = new Date();

        const age = today.getFullYear() - birthDateObj.getFullYear();
        const isBirthdayPassed =
            today.getMonth() > birthDateObj.getMonth() ||
            (today.getMonth() === birthDateObj.getMonth() && today.getDate() >= birthDateObj.getDate());

        const finalAge = isBirthdayPassed ? age : age - 1;

       // validaciones para alianza
       if (formIsAlianza) {
          const gender = watchedValues["gender"] || "";
          const isMale = gender?.toLowerCase() === "masculino";
          const isValidAge = finalAge >= 18;

          if (!isValidAge) {
             setShowAgeModal(true);
             setValue("birthdate" as any, "");
             return
          }

          // modal con mensaje de error, al ser hombre no debe tener mas de 28 años
          const maxAge = 28
          if (isMale && finalAge > maxAge) {
             setShowModalAgeAlianza(true);
             setValue("birthdate" as any, "");
          }
          return
       }


        if(finalAge < ageRequired){
            setShowAgeModal(true);
            setValue("birthdate" as any, "");
        }     
    }

    const getProgramFormName = () => {
      if(formIsAlianza) {
         return props?.tituloGeneral
      }

      return "Oportunidades de empleo para personas mayores debes tener más de 50 años."
    }

    const handleInputValueChange = (nameId: string, value: any, type?: string) => {
      // este handler se utiliza para manejar los cambios en los campos de entrada en los inputs que son no-controlado,
      // es decir aquellos inputs que se actuliza su valor mediante el controller de react-hook-form
      if(formIsAlianza && nameId === "birthdate"){
         setValue("birthdate" as any, value);
      }

    }

    useEffect(() => {
        validateHiddenFields();
        if(dataAuthorizationFields != null){
            setHasNoAuthorization(Object.values(dataAuthorizationFields).some(value => typeof value === "string" && value.toLowerCase().includes("no")));
        }
        if(watchedValues["birthdate"] && ageRequired){
            validateAge();
        }
    }, [
        watchedValues["birthdate"],
        watchedValues["disability"],
        watchedValues["havePensionIncome"],
        Object.values(dataAuthorizationFields).join(",")
    ]);

    useEffect(() => {

      if(!formIsAlianza) return

      const gender = watchedValues["gender"]
      const birthdate = watchedValues["birthdate"]
      if(gender &&  birthdate){
         // reset birthdate when gender changes
         setValue("birthdate" as any, "");   
      }
    }, [watchedValues["gender"]])


    useEffect(() => {
      // scroll to top of the form
      if(containerRef.current){
        containerRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, [activeStep, isLoading, congrats, error]);

    return (
        <section className={`${blockName} ${formIsAlianza ? "alianza" : ""} `} ref={containerRef}>
            {!congrats && !error && !isLoading && 
                <>
                    <section className={`${blockName}__header`}>
                        <h1 className={`${blockName}__title`}>{props.tituloGeneral}</h1>
                        {window.innerWidth > 768 &&
                            <div className={`${blockName}__breadcrumb ${activeStep > 0 ? "o-form-foro__breadcrumb--border":""}`}>
                                <Breadcrumb content={getPathSegments()} useCustomBreadcrumbs={formIsAlianza} customBreadcrumbs={formIsAlianza ? alianzaBreadcrumb : undefined} />
                            </div>
                        }
                        <p className={`${blockName}__description ${activeStep === 0 && blockName+"__description--left"}`}>{activeStep === 0 ? props.tituloSeccion : "Proceso de inscripción"}</p>
                        {window.innerWidth > 768 && activeStep !== 0 &&
                            <FormWizard wizards={wizards} activeIndex={activeStep-1} setActiveIndex={setActiveStep} />
                        }
                        {activeStep !== 0 &&
                            <p className={`${blockName}__wizard-mobile-text`}>Paso {activeStep} de {titulosFormulario.length}: <span className={`${blockName}__wizard-mobile-text--bold`}>{titulosFormulario[activeStep-1].tituloSeccion}</span></p>    
                        }
                        {window.innerWidth > 768 && activeStep !== 0 &&
                            <div className={`${blockName}__step-description`}>
                                {documentToReactComponents(titulosFormulario[activeStep-1].descripcion.json)}
                            </div>
                        }
                    </section>
                    {window.innerWidth <= 768 && 
                        activeStep !== 0 &&
                        <>
                            <div className={`${blockName}__wizard-mobile_arrows-button-container`}>
                                <button type="button" className={`${blockName}__form-back-button`} onClick={()=> handleBack()}><img className={`${blockName}__form-back-arrow`} src={arrowLeft} alt="Flecha izquierda"/>
                                    {activeStep > 1 ? `Paso ${activeStep-1}` : "Volver"}
                                </button>
                                {activeStep <= titulosFormulario.length-1 && (<button type="button" disabled={!isValid} className={`${blockName}__wizard-mobile_arrows-button`} onClick={()=> setActiveStep(activeStep+1)}>Paso {activeStep+1}<img className={`${blockName}__form-forward-arrow-magenta`} src={arrowLeft} alt="Flecha derecha"/></button>)}
                            </div>
                            <div className={`${blockName}__step-description`}>
                                {documentToReactComponents(titulosFormulario[activeStep-1].descripcion.json)}
                            </div>
                            <div className={`${blockName}__step-title`}>
                                {documentToReactComponents(titulosFormulario[activeStep-1].descripcionFija)}
                            </div>
                        </>
                    }
                    <section className={`${blockName}__form-container`}>
                        {activeStep <= 0 ?
                            <div>
                                <img className={`${blockName}__form-img ${blockName}__form-img--light`}  src={props.referenciaFormularios[0].imagenesEmpleo[0].file.url} />
                                <img className={`${blockName}__form-img ${blockName}__form-img--dark`}  src={props.referenciaFormularios[0].imagenesEmpleo[1].file.url} />
                                <div>
                                    <h2 className={`${blockName}__content-title`}>{props.referenciaFormularios[0].tituloPrincipal}</h2>
                                    {props.referenciaFormularios[0].descripcion.json.content[0].nodeType === "unordered-list" ?
                                            (<div className={`${blockName}__content-description`}>{documentToReactComponents(props.referenciaFormularios[0].descripcion.json, options)}</div>)
                                        :
                                            (<div className={`${blockName}__content-description`}>{documentToReactComponents(props.referenciaFormularios[0].descripcion.json)}</div>)
                                    }
                                    <button type="button" className={`${blockName}__form-cta`} onClick={()=> setActiveStep(1)}>Continuar <img className={`${blockName}__form-forward-arrow`} src={arrowLeft} alt="Flecha derecha"/></button>

                                    {
                                       formIsAlianza && window.innerWidth > 768 ? (
                                          <div>
                                             <button
                                                type="button"
                                                className={`${blockName}__form-cancel`}
                                                onClick={() => { setShowModalLeaveForm(true); }}
                                             >
                                                Cancelar
                                             </button>
                                          </div>
                                       ) : null
                                    }
                                </div>
                            </div>
                        :
                            <>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    {window.innerWidth > 768 &&
                                        <figure>
                                            {titulosFormulario[activeStep - 1].listaImagenes?.length > 0 ? (
                                                <div className={`${blockName}__form-desktop-img-multi`}>
                                                    {titulosFormulario[activeStep - 1].listaImagenes.map((input, index) => {
                                                        const shouldRender =
                                                            index !== 1 || 
                                                            ((watchedValues["disability"] === "Si" || 
                                                                watchedValues["havePensionIncome"] === "Si") && index === 1);

                                                        return shouldRender ? (
                                                            <img 
                                                                key={index} 
                                                                className={`${blockName}__form-desktop-img-multi__${index}`} 
                                                                src={input.file.url} 
                                                                alt={`Imagen ${index + 1}`} 
                                                            />
                                                        ) : null;
                                                    })}
                                                </div>
                                            ) : (
                                                <img 
                                                    className={`${blockName}__form-desktop-img`} 
                                                    src={titulosFormulario[activeStep - 1].imagenPrincipal.file.url} 
                                                    alt="Imagen principal"
                                                />
                                            )}
                                        </figure> 
                                    }
                                    <div>
                                        {window.innerWidth > 768 && titulosFormulario[activeStep-1].descripcionFija &&
                                            <>
                                                <div className={`${blockName}__step-title`}>
                                                    {documentToReactComponents(titulosFormulario[activeStep-1].descripcionFija)}
                                                </div>
                                            </>
                                        }
                                        {titulosFormulario[activeStep-1].referenciaFormulario.map((input, index) => {
                                            const isDate = input?.tipoCampo === "date";
                                            if(isDate && formIsAlianza) {
                                               input.tipoCampo = "datev2";
                                            }

                                            const useCurrentValue = formIsAlianza

                                            const inputHasError = !!errors[input.nombreId];
                                            const errorMsg = errors[input.nombreId]?.message || "";
                                               
                                             
                                            if(!input.deshabilitado) {
                                                return(
                                                    <FormInput
                                                        key={`input-${input.nombreId}-${index}`}
                                                        title={input.inputPrincipal}
                                                        nombreId={input.nombreId}
                                                        placeholder={input.placeholder? input.placeholder : ""}
                                                        type={input.tipoCampo}
                                                        maxCharacters={input.maximosCaracteres}
                                                        isRequired={input.obligatorio}
                                                        options={input.listaSelect}
                                                        icon={input.icon}
                                                        listValue={[]}
                                                        value={useCurrentValue ? watchedValues[input.nombreId] : ""}
                                                        setInputValue={handleInputValueChange}
                                                        register={register}
                                                        isError={inputHasError}
                                                        tituloBotonTerminos={input.tituloBotonTerminos}
                                                        textoTerminos={input.textoTerminos}
                                                        ayuda={input.ayuda}
                                                        seccion={input.seccion}
                                                        errorMessage={inputHasError ? errorMsg || input.mensajeError : ""}
                                                        control={control}
                                                    />
                                                )         
                                            }
                                        })}
                                        {hasNoAuthorization && (
                                            <ToastAdvertiser
                                                imgSrc={warningSvg}
                                                text="Para continuar debes aceptar el tratamiento de datos."
                                                imgBgColor="#FF0000"
                                            />
                                        )}
                                        {activeStep === titulosFormulario.length && window.innerWidth <= 768 &&
                                            <button type="submit" disabled={!isValid} className={`${blockName}__form-cta`}>{formIsAlianza ? "Enviar" : "Finalizar"} <img className={`${blockName}__form-forward-arrow`} src={arrowLeft} alt="Flecha derecha"/></button>  
                                        }
                                        {window.innerWidth > 768 && 
                                            <div>
                                                <div className={`${blockName}__form-cta-container`}>
                                                    <button type="button" className={`${blockName}__form-back-cta`} onClick={()=> setActiveStep(activeStep -1)}>
                                                      {/* <img className={`${blockName}__form-back-arrow`} src={arrowLeft} alt="Flecha derecha"/>  */}
                                                      <ArrowRigth />
                                                      Volver
                                                    
                                                    </button>
                                                    {activeStep === titulosFormulario.length ? <button type="submit" disabled={!isValid} className={`${blockName}__form-cta`}>{formIsAlianza ? "Enviar" : "Finalizar"} <img className={`${blockName}__form-forward-arrow`} src={arrowLeft} alt="Flecha derecha"/></button> : <button type="button" disabled={!isValid} className={`${blockName}__form-cta`} onClick={()=> setActiveStep(activeStep + 1)}>Continuar <img className={`${blockName}__form-forward-arrow`} src={arrowLeft} alt="Flecha derecha"/></button>}
                                                </div>
                                                <button
                                                    type="button"
                                                    className={`${blockName}__form-cancel`}
                                                    onClick={() => {setShowModalCancelar(true);}}
                                                >
                                                    Cancelar
                                                </button>
                                            </div>
                                        }
                                    </div>
                                </form>
                            </>
                        }
                        {activeStep < titulosFormulario.length && activeStep > 0 && window.innerWidth <= 768 &&
                            <button type="button" disabled={!isValid} className={`${blockName}__form-cta`} onClick={()=> setActiveStep(activeStep + 1)}>Continuar <img className={`${blockName}__form-forward-arrow`} src={arrowLeft} alt="Flecha derecha"/></button>  
                        }
                    </section>
                    {(window.innerWidth <= 768) &&
                        <button
                            type="button"
                            className={`${blockName}__form-cancel`}
                            onClick={() => {setShowModalCancelar(true);}}
                        >
                            Cancelar
                        </button>
                    }
                    {showModalCancelar && (
                        <div className={`${blockName}__modal-cancelar`}>
                            <Modal
                                showModal={showModalCancelar}
                                onClose={closeCancelForm}
                            >
                                <div className={`${blockName}__modal-cancelar__container`}>
                                    <h3>¿Estás seguro que quieres cancelar la inscripción?</h3>
                                    <div className="buttons">
                                        <div className="buttons__cancelar">
                                            <Button
                                                type="button"
                                                classname="a-button__magenta"
                                                text={"Continuar mi inscripción"}
                                                isDisabled={false}
                                                onClickAction={() => {
                                                    closeCancelForm()
                                                }}
                                            />
                                        </div>
                                        <div className="buttons__continuar">
                                            <Button
                                                type="button"
                                                classname="a-button primary"
                                                text={"Cancelar mi inscripción"}
                                                isDisabled={false}
                                                onClickAction={() => {
                                                    navigate('../')
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Modal>
                        </div>
                    )}
                </>
            }
            {congrats && formResultSuccessful != "" && (
                <FormResult
                    image={formResultSuccessful.imagenPrincipal[0]}
                    title={formResultSuccessful.tituloBanner}
                    titleDescription={formResultSuccessful?.tituloDescripcion ?? ""}
                    description={documentToReactComponents(formResultSuccessful?.descripcion?.json ?? "")}
                    fixedDescription={documentToReactComponents(formResultSuccessful?.descripcionFija ?? "")}
                    titleButton={formResultSuccessful.tituloBoton}
                    buttonUrl={formResultSuccessful.redireccionBoton}
                    self
                />
            )}
            {error && formResultError != "" && (
                <FormResult
                    image={formResultError.imagenPrincipal[0]}
                    title={formResultError.tituloBanner}
                    titleDescription={formResultError?.tituloDescripcion ?? ""}
                    description={documentToReactComponents(formResultError?.descripcion?.json ?? "")}
                    fixedDescription={documentToReactComponents(formResultError?.descripcionFija ?? "")}
                    titleButton={formResultError.tituloBoton}
                    buttonUrl={formResultError.redireccionBoton}
                    self
                />
            )}
            {showAgeModal && (
                <div className={`${blockName}__modal-edad`}>
                    <Modal
                        showModal={showAgeModal}
                        onClose={closeCancelForm}
                    >
                        <div className={`${blockName}__modal-edad__container`}>
                            <img
                                className={`${blockName}__modal-edad__container__image`}
                                src="https://images.ctfassets.net/203frbsx1z3n/1ReUpXs1rWXrp5H0Sa7nDH/9d8daa228206a1609b643a270fd8db37/error__4_.png"
                            />
                            <h1 className={`${blockName}__modal-edad__container__title`}>Lo sentimos, no cumples con la edad mínima</h1>
                            <p className={`${blockName}__modal-edad__container__description`}>
                                Para inscribirte en el programa de {getProgramFormName()}
                            </p>
                            <Button
                                type="button"
                                text={"Entendido"}
                                classname={`a-button__magenta`}
                                isDisabled={false}
                                onClickAction={() => {
                                    setShowAgeModal(false)
                                }}
                            />
                        </div>
                    </Modal>
                </div>
            )}

             <ModalAge
                modalIsOpen={showModalAgeAlianza}
                onConfirm={() => {
                    setShowModalAgeAlianza(false);
                }}
                onClose={() => {
                    setShowModalAgeAlianza(false);
                }}
                title={
                  <>
                      Lo sentimos, no cumples con algunos <br className="hide-down-md" />
                      requisitos para acceder al programa ya que <br className="hide-down-md" />
                      eres hombre mayor de 28 años.
                  </>
                }
                description={""}
            />

            {showModalLeaveForm ? (
               <ModalDecision
                  isOpen
                  title="¿Deseas salir del formulario de inscripción?"
                  confirmLink="https://www.comfama.com/servicio-de-empleo/personas/proyectos-inclusion-laboral/alianza/"
                  confirmText="Si"
                  cancelText="No"
                  onCancel={() => {
                     setShowModalLeaveForm(false);
                  }}
                  onCloseModal={() => {
                     setShowModalLeaveForm(false);
                  }}
               />
            ) : null}

          {/* Modal cierre de convocatoria del formulario */}
          {
             disabledModalData?.disabled && disabledModalData?.conntent ? (
                <div className={`${blockName}__modal-cierre`}>
                   <ModalAge
                      modalIsOpen={true}
                      onConfirm={() => {
                        navigate(disabledModalData?.conntent?.redireccionBoton as string);
                      }}
                      onClose={() => {
                        navigate(disabledModalData?.conntent?.redireccionBoton as string);
                      }}
                      title={disabledModalData?.conntent?.tituloPrincipal}
                      description={rawToReact(disabledModalData.conntent.descripcion.raw, contentfulRenderOptions)}
                      btnText={disabledModalData.conntent?.tituloBoton}
                   />
                </div>
             ) : null
          }
        

            {isLoading && (
                <div className="loading">
                    <Loading />
                </div>
            )}
        </section>
    );
}

export default FormForoInclusivo;
